<template>
  <swiper
    v-if="imgs && imgs.length > 0"
    :modules="[Mousewheel, Virtual, Pagination]"
    :mousewheel="{ forceToAxis: true }"
    :virtual="{ addSlidesAfter: 1, addSlidesBefore: 1, enabled: true }"
    :pagination="{
      el: '.swiper-pagination',
      direction: 'vertical',
      dynamicBullets: true,
      dynamicMainBullets: 1,
    }"
    :direction="'vertical'"
    :loop="imgs.length > 2"
    :slides-per-view="1"
    :slides-per-group="1"
    :auto-height="true"
    @slide-change-transition-end="slideChanged()"
    @tap="slideChanged()"
    style="width: 100%; height: 100%"
  >
    <swiper-slide
      v-for="(url, index) in imgs"
      :key="index"
      :virtual-index="index"
      style="height: 100%; width: 100%"
    >
      <div
        class="unit-img"
        :style="{
          backgroundImage: `url(${url})`,
          borderRadius: '0px',
        }"
      ></div>
    </swiper-slide>
    <div class="swiper-pagination"></div>
  </swiper>
  <div
    v-else
    style="
      width: 100%;
      height: 100%;
      background-color: var(--gray-light);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
    <span
      class="secondary secondary-small black-default"
      :style="{
        fontSize: '10px',
      }"
      >NO IMAGES</span
    >
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
      "
    >
      <img src="../../assets/logo_avatar.svg" />
    </div>
  </div>
</template>

<script setup>
import { Mousewheel, Virtual, Pagination } from "swiper/modules";
import { defineEmits } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";

defineProps({
  imgs: { type: Array },
});

const emit = defineEmits(["slideChanged"]);

/**
 * @param {number} unitId
 */
// Expand slider if it's not already expanded after swipe
function slideChanged() {
  console.log("slideChanged", true);
  emit('slideChanged', true);
}
</script>

<style scoped>
.swiper-pagination {
  --swiper-pagination-left: 7px;
  --swiper-pagination-color: var(--white-default);
  --swiper-pagination-bullet-inactive-color: var(--white-default);
  --swiper-pagination-bullet-inactive-opacity: 1;
  width: 13px !important;
  transform: none !important;
  top: auto !important;
}

.swiper-pagination-vertical {
  bottom: 10px;
}

.unit-img {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: white;
}
</style>